import { pathOr } from 'ramda'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { activateTrialMode } from '@/app/module/auth/store/session.slice'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectActiveOrg, selectOrgId, selectUserId } from '@/app/module/user/store/selectors'

import { selectToken } from '../auth/store/selectors'
import Plans from './component'
import { getPlans, subscribePlan } from './store/actions'
import { selectPlans } from './store/selectors'

const selector = (state) => {
  const { user, plans } = state
  return {
    error: pathOr([], ['list', 'error'], plans) || pathOr([], ['item', 'error'], plans),
    isLoading:
      pathOr(false, ['list', 'loading'], plans) ||
      pathOr(false, ['item', 'loading'], plans) ||
      user.details.loading ||
      user.organization.loading,
    plans: selectPlans(plans),
    token: selectToken(),
    orgId: selectOrgId({ user }),
    userId: selectUserId({ user }),
    profile: pathOr({}, ['details', 'data'], user),
    hydrateProps: ['token', 'orgId'],
    activeOrg: selectActiveOrg({ user }),
  }
}

const dispatcher = (dispatch) =>
  bindActionCreators(
    {
      hydrate:
        ({ token }) =>
        () =>
          dispatch(getPlans({ token })),
      subscribePlan,
      createNotification,
      activateTrialMode,
    },
    dispatch,
  )

export default connect(selector, dispatcher)(withRouter(Plans))
